import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  initials: 'VT',
  name: 'Valeria T.',
  role: 'Docente técnica agropecuaria — Lima, Perú',
  text: 'El material sobre razas bovinas y sistemas de producción le cambió la cara a mis alumnos. Por fin entienden las diferencias sin confundirse. Es el recurso más claro que encontré para este tema. Lo uso desde la primera clase y los engancha de inmediato.'
}, {
  initials: 'CR',
  name: 'Carlos R.',
  role: 'Profesor técnico rural — Montevideo, Uruguay',
  text: 'El banco de evaluaciones vale por sí solo el precio del pack. Nunca más construí un examen agropecuario desde cero bajo presión. Salgo de cada trimestre con la satisfacción de tener todo resuelto.'
}, {
  initials: 'DG',
  name: 'Daniel G.',
  role: 'Docente de producción vegetal — Caracas, Venezuela',
  text: 'El módulo de riego y maquinaria transformó al grupo más difícil que tenía. Lo proyecto al inicio de la clase práctica y mis alumnos saben exactamente qué sistema van a usar y por qué. Eso no lo encontré en ningún otro material.'
}, {
  initials: 'AM',
  name: 'Ana M.',
  role: 'Docente rural — Buenos Aires, Argentina',
  text: 'El complemento de vivero fue una revelación. Armé el vivero escolar en dos semanas usando el material como guía. Mis alumnos propagaron plantas por primera vez y lo entendieron todo. Eso no lo había logrado en cinco años.'
}, {
  initials: 'SR',
  name: 'Sebastián R.',
  role: 'Profesor agropecuario — Quito, Ecuador',
  text: 'El tomo de sustentabilidad me permitió enseñar agroecología por primera vez de manera coherente. Mis alumnos conectaron la producción con el cuidado del ambiente. Eso cambió completamente el sentido de la materia para ellos.'
}];
export function ExtendedTestimonials() {
  return <section className="py-24 px-4 bg-white border-y border-earth/20" data-id="element-64" data-mp="26aj3wut6mhe2">
      <div className="max-w-6xl mx-auto" data-id="element-65" data-mp="26dezichk4tzc">
        <div className="text-center mb-16" data-id="element-66" data-mp="27rzijj3p34s6">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-slate-900" data-id="element-67" data-mp="27q4ye708zgp5">
            Lo que dicen los docentes que ya tienen su Mega Pack
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-68" data-mp="1yr1e4zpcgv92">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className={`bg-cream border border-earth/10 p-8 rounded-2xl relative shadow-sm ${i === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-69" data-mp="23ot8e0dgotgf" data-mpi={i}>
              <Quote className="absolute top-6 right-6 text-forest/10" size={48} data-id="element-70" data-mp="1b1p8uax517c1" />

              <div className="flex gap-1 text-gold mb-6" data-id="element-71" data-mp="rh8bkyfk8dtj">
                {[...Array(5)].map((_, j) => <Star key={j} size={16} fill="currentColor" data-id="element-72" data-mp="midp9midw74o" data-mpi={j} />)}
              </div>

              <p className="text-slate-700 italic mb-8 relative z-10 leading-relaxed" data-id="element-73" data-mp="11fxsanvpzs87">
                "{t.text}"
              </p>

              <div className="flex items-center gap-4 mt-auto" data-id="element-74" data-mp="whmgw8ps19nv">
                <div className="w-12 h-12 rounded-full bg-forest text-cream flex items-center justify-center font-bold text-lg" data-id="element-75" data-mp="1adgh83chiqpd">
                  {t.initials}
                </div>
                <div data-id="element-76" data-mp="1k3sxvkh6hzq8">
                  <div className="font-bold text-slate-900" data-id="element-77" data-mp="1k4b67fh484ei">{t.name}</div>
                  <div className="text-xs text-earth" data-id="element-78" data-mp="1f6srt9kbwwz4">{t.role}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}